import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

import Login from "./pages/admin/Login";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import PagesList from "./pages/admin/PagesList";
import PageBuilder from "./pages/admin/PageBuilder";
import Registrations from "./pages/admin/Registrations";
import RegistrationDetail from "./pages/admin/RegistrationDetail";
import WaInbox from "./pages/admin/WaInbox";
import Duplicates from "./pages/admin/Duplicates";
import PaymentDetail from "./pages/admin/PaymentDetail";
import SchoolStudents from "./pages/admin/SchoolStudents";
import StudentProfile from "./pages/admin/StudentProfile";
import Students from "./pages/admin/Students";
import Schools from "./pages/admin/Schools";
import Reports from "./pages/admin/Reports";
import Settings from "./pages/admin/Settings";
import AccountSettings from "./pages/admin/AccountSettings";import AuditLogs from "./pages/admin/AuditLogs";
import AdminUsers from "./pages/admin/AdminUsers";
import Bin from "./pages/admin/Bin";
import Webhooks from "./pages/admin/Webhooks";
import BulkWhatsApp from "./pages/admin/BulkWhatsApp";
import PaymentVerification from "./pages/admin/PaymentVerification";
import PublicPage from "./pages/public/PublicPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Root() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  return <Navigate to={user ? "/admin/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Root />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/r/:slug" element={<PublicPage />} />
            <Route
              path="/admin"
              element={
                <Protected>
                  <AdminLayout />
                </Protected>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pages" element={<PagesList />} />
              <Route path="pages/new" element={<PageBuilder />} />
              <Route path="pages/:id/edit" element={<PageBuilder />} />
              <Route path="registrations" element={<Registrations />} />
              <Route path="registrations/:rid" element={<RegistrationDetail />} />
              <Route path="payments/:id" element={<PaymentDetail />} />
              <Route path="bin" element={<Bin />} />
              <Route path="duplicates" element={<Duplicates />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:sid" element={<StudentProfile />} />
              <Route path="schools" element={<Schools />} />
              <Route path="schools/:sid/students" element={<SchoolStudents />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              <Route path="account-settings" element={<AccountSettings />} />
              <Route path="audit-logs" element={<AuditLogs />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="whatsapp-bulk" element={<BulkWhatsApp />} />
              <Route path="whatsapp-inbox" element={<WaInbox />} />
              <Route path="payment-verification" element={<PaymentVerification />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
